import React from "react";
import LocationTypeGrid from "./LocationTypeGrid";

const LocationTypePage = () => {
  return (
    <div className="c-main">
      <div className="c-content">
        <LocationTypeGrid />
      </div>
    </div>
  );
};
export default LocationTypePage;
